import * as Api from '@ViewModels';
import { MutationScope, useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface Params {
	configId: string;
	/** Null or empty clears the assignment */
	categoryId?: string;
	forUserId?: string;
}

export function useSchedulerConfigUpdateCategoryMutation({
	onSuccess,
	onError,
	scope,
}: {
	onSuccess?: (data: Api.IMeetingConfigResponse) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	scope?: MutationScope;
}) {
	const userSession = useUserSession();

	return useMutation({
		scope,
		mutationFn: async ({ configId, categoryId, forUserId }: Params) => {
			const queryParams: Record<string, string | number> = {};
			if (categoryId) {
				queryParams.categoryId = categoryId;
			}
			if (forUserId) {
				queryParams.forUserId = forUserId;
			}

			return userSession.webServiceHelper.callAsync<Api.IMeetingConfigResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `scheduler/config/${configId}/CategoryId`,
					queryParams,
				}),
				categoryId ? 'PUT' : 'DELETE'
			);
		},
		onSuccess,
		onError,
	});
}
